module.exports = __webpack_public_path__ + "static/img/GUY-JENKIN.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GUY-JENKIN.jpg
// module id = 7XfW
// module chunks = 0